import { render, staticRenderFns } from "./DetailStoreOrderComponent.vue?vue&type=template&id=73311b3e&scoped=true"
import script from "./DetailStoreOrderComponent.vue?vue&type=script&lang=js"
export * from "./DetailStoreOrderComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailStoreOrderComponent.vue?vue&type=style&index=0&id=73311b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73311b3e",
  null
  
)

export default component.exports